import React from 'react';
import { SimpleSticky } from '../SimpleSticky';
import { useOldStickyProps } from './useOldStickyProps';
import { jsx as _jsx } from "react/jsx-runtime";
export var OldSticky = function OldSticky(props) {
  var onBottomStuck = props.onBottomStuck,
    onTopStuck = props.onTopStuck,
    top = props.top,
    bottom = props.bottom,
    zIndex = props.zIndex,
    position = props.position,
    intersectionOffset = props.intersectionOffset,
    children = props.children,
    _props$testId = props.testId,
    testId = _props$testId === void 0 ? 'oldSticky' : _props$testId,
    root = props.root;
  var _useOldStickyProps = useOldStickyProps({
      children: children,
      onBottomStuck: onBottomStuck,
      onTopStuck: onTopStuck,
      root: root
    }),
    sentinelRef = _useOldStickyProps.sentinelRef,
    isOnBottomStuck = _useOldStickyProps.isOnBottomStuck,
    isOnTopStuck = _useOldStickyProps.isOnTopStuck;
  return /*#__PURE__*/_jsx(SimpleSticky, {
    ref: sentinelRef,
    zIndex: zIndex,
    bottom: bottom,
    top: top,
    testId: testId,
    isOnBottomStuck: isOnBottomStuck,
    isOnTopStuck: isOnTopStuck,
    position: position,
    intersectionOffset: intersectionOffset,
    children: children
  });
};
OldSticky.displayName = 'OldSticky';